import { AccountStatus, IAccount } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorAccountWithdrawalReady = (account: IAccount) =>
  account.status !== AccountStatus.Inactive && account.canBeUsedFor?.payouts;
